module.exports = __webpack_public_path__ + "static/media/ASO_Garden_Real_Estate_Flyer.14d10e86.png";